import featureNames from 'constants/feature_names';

angular.module('filters').filter('membershipPlanSequenceUpfrontCost', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(plan, currency) {
    var amount, date, direction, interval, symbol;
    if (plan.cost_upfront > 0) {
      date = (function() {
        switch (plan.default_upfront_date_strategy) {
          case 'charge_upfront_amount_on_start_date':
            return 'when membership starts';
          case 'charge_upfront_amount_relative_to_start_date':
            interval = $filter('pluralize')(plan.relative_upfront_date_unit, plan.relative_upfront_date_number, true);
            direction = plan.relative_upfront_date_direction;
            return `${interval} ${direction} membership starts`;
          case 'charge_upfront_amount_asap':
            return `charged when the ${featureNames.SEQUENCE_LOWERCASE} fires`;
        }
      })();
      symbol = currency || $rootScope.gym.currency_symbol;
      amount = $filter('currency')(plan.cost_upfront, symbol);
      return `${amount}, charged ${date}`;
    } else {
      return "No initial payment";
    }
  };
}]);
